export const INVOICE_MESSAGE_CHARACTER_LIMIT = 1000
